const regexDiceNotation = "([2-9]|[1-9]\\d*)?(D[36])?(\\+[1-9]\\d*)?"

export { regexDiceNotation }
